import Handler from "../Handler";
class RITRejectHandler extends Handler {
    execute(message) {
      let receivedData = JSON.parse(message);
      this.service.processRITReject(receivedData);
    }
  }
  
  export default RITRejectHandler;